/* THIS FILE WAS AUTOGENERATED BY CLUTCH. DO NOT EDIT. */
import React from 'react';
import * as b from '@clutch-creator/bridge';
import useLogic from './logic.js';
import HelmetTitle from '@clutch-marketplace/helmet/dist/cjs/components/HelmetTitle';
import Box from '@clutch-marketplace/web-elements/dist/cjs/components/Box';
import UseParams from '@clutch-marketplace/react-router/dist/cjs/components/UseParams';
import UseApplicationOffer from '../UseApplicationOffer';
import conditionFn from './code/if/conditionFn.js';
import Element from '@clutch-marketplace/element/dist/cjs/components/Element';
import OfferLetterHero from '../OfferLetterHero';
import Text from '@clutch-marketplace/web-elements/dist/cjs/components/Text';
import conditionFn1 from './code/if/conditionFn-1.js';
import Image from '@clutch-marketplace/web-elements/dist/cjs/components/Image';
import textFn from './code/text/textFn.js';
import textFn1 from './code/text/textFn-1.js';
import textFn2 from './code/text/textFn-2.js';
import conditionFn2 from './code/if/conditionFn-2.js';
import textFn3 from './code/text/textFn-3.js';
import conditionFn3 from './code/if/conditionFn-3.js';
import textFn4 from './code/text/textFn-4.js';
import HTMLElement from '../HTMLElement';
import innerHTMLFn from './code/hTMLElement/innerHTMLFn.js';
import textFn5 from './code/text/textFn-5.js';
import textFn6 from './code/text/textFn-6.js';
import textFn7 from './code/defaulttext50/textFn-7.js';
import textFn8 from './code/text/textFn-8.js';
import textFn9 from './code/text/textFn-9.js';
import textFn10 from './code/text/textFn-10.js';
import UseState from '@clutch-marketplace/clutch.clutch-react-toolkit/dist/cjs/components/UseState';
import conditionFn4 from './code/if/conditionFn-4.js';
import UseForm from '@clutch-marketplace/paragonone.react-hook-form/dist/cjs/components/UseForm';
import Icon from '../Icon';
import textFn11 from './code/text/textFn-11.js';
import itemsFn from './code/loop/itemsFn.js';
import TextField from '../TextField';
import registerFn from './code/textField/registerFn.js';
import CheckboxField from '../CheckboxField';
import registerFn1 from './code/checkboxField/registerFn-1.js';
import registerFn2 from './code/checkboxField/registerFn-2.js';
import registerFn3 from './code/checkboxField/registerFn-3.js';
import registerFn4 from './code/checkboxField/registerFn-4.js';
import Button from '../Button';
import loadingFn from './code/button/loadingFn.js';
import disabledFn from './code/button/disabledFn.js';
import onClickFn from './code/button/onClickFn.js';
import Button1 from '@clutch-marketplace/web-elements/dist/cjs/components/Button';
import onClickFn1 from './code/button/onClickFn-1.js';
import conditionFn5 from './code/if/conditionFn-5.js';
import Controller from '@clutch-marketplace/paragonone.react-hook-form/dist/cjs/components/Controller';
import ReactSelect from '../ReactSelect';
import registerFn5 from './code/textField/registerFn-5.js';
import registerFn6 from './code/checkboxField/registerFn-6.js';
import loadingFn1 from './code/button/loadingFn-1.js';
import disabledFn1 from './code/button/disabledFn-1.js';
import onClickFn2 from './code/button/onClickFn-2.js';
import onClickFn3 from './code/button/onClickFn-3.js';
import Popup from '../Popup';
import onClickFn4 from './code/button10/onClickFn-4.js';
import openFn from './code/popupfinishdeclineflow/openFn.js';
import initialValueFn from './code/usestatecurrentform/initialValueFn.js';
import conditionFn6 from './code/if/conditionFn-6.js';
import Accordion from '../Accordion';
import Link from '@clutch-marketplace/web-elements/dist/cjs/components/Link';
import styleFn from './code/defaultbox90/styleFn.js';
import conditionFn7 from './code/if/conditionFn-7.js';
import onViewOfferDetailsFn from './code/offerLetterHero/onViewOfferDetailsFn.js';
import conditionFn8 from './code/if/conditionFn-8.js';
import srcFn from './code/image/srcFn.js';
import IfElse from '@clutch-marketplace/logic/dist/cjs/components/IfElse';
import TooltipClickWrapper from '../TooltipClickWrapper';
import TooltipWrapper from '../TooltipWrapper';
import hideFn from './code/tooltipWrapper/hideFn.js';
import conditionFn9 from './code/ifElse/conditionFn-9.js';
import conditionFn10 from './code/if/conditionFn-10.js';
import textFn12 from './code/text/textFn-12.js';
import itemsFn1 from './code/loop/itemsFn-1.js';
import conditionFn11 from './code/if/conditionFn-11.js';
import conditionFn12 from './code/if/conditionFn-12.js';
import PoweredByParagonOne from '../PoweredByParagonOne';
import textFn13 from './code/text/textFn-13.js';
import Loading from '../Loading';
import conditionFn13 from './code/if/conditionFn-13.js';
import _404 from '../404';
import styles from './styles.module.scss';

const OfferLetterPage = React.forwardRef((propsArg, ref) => {
  const variants = {};
  const theme = b.useTheme();
  const vars = { theme, ...useLogic(propsArg) };
  const [report, getKey, props] = b.useReport(
    '69_13',
    propsArg,
    vars,
    variants
  );

  return (
    <>
      <HelmetTitle
        title="Offer Letter Page"
        className={props.className}
        ref={ref}
        key={getKey(report, '82_481')}
      />
      <Box tag="div" key={getKey(report, '93_161')}>
        <UseParams
          key={getKey(report, '77_103')}
          data-d={getKey(report, '77_103')}
        >
          {(
            (prevReport) =>
            (...args) => {
              const [report, vars] = b.getReport(
                '77_103',
                'children',
                prevReport,
                'defaultUseParams2',
                args
              );

              return (
                <UseApplicationOffer
                  applicationID={vars?.defaultUseParams2?.applicationID}
                  loginString={vars?.defaultUseParams2?.loginString}
                  key={getKey(report, '77_91')}
                >
                  {(
                    (prevReport) =>
                    (...args) => {
                      const [report, vars] = b.getReport(
                        '77_91',
                        'children',
                        prevReport,
                        'useapplicationoffer2',
                        args
                      );

                      return [
                        getKey(report, '81_128', null, '__CLUTCH_IF__') &&
                        b.tryCatch(conditionFn, props, vars) ? (
                          <Element key={getKey(report, 'v200_103267')}>
                            <OfferLetterHero
                              mode="proposal"
                              applicationOffer={
                                vars?.useapplicationoffer2?.applicationOffer
                              }
                              key={getKey(report, '69_32')}
                              data-d={getKey(report, '69_32')}
                            />
                            <Box
                              tag="div"
                              id="offer-letter-main"
                              className={styles.clt_70_236}
                              key={getKey(report, '70_236')}
                            >
                              <Box
                                tag="div"
                                className={styles.clt_72_90}
                                key={getKey(report, '72_90')}
                              >
                                <Box
                                  tag="div"
                                  className={styles.clt_72_92}
                                  key={getKey(report, '72_92')}
                                >
                                  <Box
                                    tag="div"
                                    className={styles.clt_72_93}
                                    key={getKey(report, '72_93')}
                                  >
                                    <Box
                                      tag="div"
                                      className={styles.clt_72_94}
                                      key={getKey(report, '72_94')}
                                    >
                                      <Box
                                        tag="div"
                                        className={styles.clt_72_95}
                                        key={getKey(report, '72_95')}
                                      />
                                    </Box>
                                    <Box
                                      tag="div"
                                      className={styles.clt_72_96}
                                      key={getKey(report, '72_96')}
                                    >
                                      <Box
                                        tag="div"
                                        className={styles.clt_72_97}
                                        key={getKey(report, '72_97')}
                                      />
                                      <Box
                                        tag="div"
                                        className={styles.clt_72_98}
                                        key={getKey(report, '72_98')}
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                                <Box
                                  tag="div"
                                  className={styles.clt_72_91}
                                  key={getKey(report, '72_91')}
                                />
                                <Box
                                  tag="div"
                                  className={styles.clt_72_99}
                                  key={getKey(report, '72_99')}
                                >
                                  <Box
                                    tag="div"
                                    className={styles.clt_72_100}
                                    key={getKey(report, '72_100')}
                                  >
                                    <Box
                                      tag="div"
                                      className={styles.clt_72_101}
                                      key={getKey(report, '72_101')}
                                    >
                                      <Box
                                        tag="div"
                                        className={styles.clt_72_102}
                                        key={getKey(report, '72_102')}
                                      />
                                    </Box>
                                    <Box
                                      tag="div"
                                      className={styles.clt_72_103}
                                      key={getKey(report, '72_103')}
                                    >
                                      <Box
                                        tag="div"
                                        className={styles.clt_72_104}
                                        key={getKey(report, '72_104')}
                                      />
                                      <Box
                                        tag="div"
                                        className={styles.clt_72_105}
                                        key={getKey(report, '72_105')}
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                              <Box
                                tag="div"
                                className={styles.clt_70_242}
                                key={getKey(report, '70_242')}
                              >
                                <Box
                                  tag="div"
                                  className={styles.clt_70_243}
                                  key={getKey(report, '70_243')}
                                >
                                  <Text
                                    text="Offer Letter"
                                    tag="h3"
                                    className={styles.clt_70_244}
                                    key={getKey(report, '70_244')}
                                  />
                                  {getKey(
                                    report,
                                    '70_273',
                                    null,
                                    '__CLUTCH_IF__'
                                  ) && b.tryCatch(conditionFn1, props, vars) ? (
                                    <Box
                                      tag="div"
                                      className={styles.clt_v200_103180}
                                      key={getKey(report, 'v200_103180')}
                                    >
                                      <Image
                                        src={
                                          vars?.useapplicationoffer2
                                            ?.applicationOffer?.company_logo
                                        }
                                        className={styles.clt_70_245}
                                        key={getKey(report, '70_245')}
                                      />
                                    </Box>
                                  ) : null}
                                </Box>
                                <Box
                                  tag="div"
                                  className={styles.clt_72_59}
                                  key={getKey(report, '72_59')}
                                >
                                  <Text
                                    text={b.tryCatch(textFn, props, vars)}
                                    tag="p"
                                    className={styles.clt_72_69}
                                    key={getKey(report, '72_69')}
                                  />
                                </Box>
                              </Box>
                            </Box>
                            <Box
                              tag="div"
                              className={styles.clt_84_334}
                              key={getKey(report, '84_334')}
                            >
                              <Box
                                tag="div"
                                className={styles.clt_84_0}
                                key={getKey(report, '84_0')}
                              >
                                <Text
                                  text="Offer Details"
                                  tag="h2"
                                  className={styles.clt_84_10}
                                  key={getKey(report, '84_10')}
                                />
                                {getKey(
                                  report,
                                  '207_24',
                                  null,
                                  '__CLUTCH_IF__'
                                ) && vars?.isInViewOfferDetailsMode ? (
                                  <Box
                                    tag="div"
                                    className={styles.clt_208_66}
                                    key={getKey(report, '208_66')}
                                  >
                                    <Text
                                      text={b.tryCatch(textFn1, props, vars)}
                                      tag="span"
                                      className={styles.clt_206_522}
                                      key={getKey(report, '206_522')}
                                    />
                                    <Box
                                      tag="div"
                                      className={styles.clt_208_49}
                                      key={getKey(report, '208_49')}
                                    >
                                      {getKey(
                                        report,
                                        '208_187',
                                        null,
                                        '__CLUTCH_IF__'
                                      ) &&
                                      b.tryCatch(conditionFn2, props, vars) ? (
                                        <Text
                                          text={b.tryCatch(
                                            textFn2,
                                            props,
                                            vars
                                          )}
                                          tag="span"
                                          className={styles.clt_208_58}
                                          key={getKey(report, '208_58')}
                                        />
                                      ) : null}
                                      {getKey(
                                        report,
                                        '208_205',
                                        null,
                                        '__CLUTCH_IF__'
                                      ) &&
                                      b.tryCatch(conditionFn3, props, vars) ? (
                                        <Text
                                          text={b.tryCatch(
                                            textFn3,
                                            props,
                                            vars
                                          )}
                                          tag="span"
                                          className={styles.clt_208_132}
                                          key={getKey(report, '208_132')}
                                        />
                                      ) : null}
                                    </Box>
                                  </Box>
                                ) : null}
                                <Box
                                  tag="div"
                                  className={styles.clt_84_15}
                                  key={getKey(report, '84_15')}
                                >
                                  <Text
                                    text={b.tryCatch(textFn4, props, vars)}
                                    tag="h3"
                                    key={getKey(report, '84_16')}
                                  />
                                  <HTMLElement
                                    tag="div"
                                    innerHTML={b.tryCatch(
                                      innerHTMLFn,
                                      props,
                                      vars
                                    )}
                                    className={styles.clt_142_274}
                                    key={getKey(report, '142_274')}
                                    data-d={getKey(report, '142_274')}
                                  />
                                </Box>
                                <Box
                                  tag="div"
                                  className={styles.clt_84_82}
                                  key={getKey(report, '84_82')}
                                >
                                  <Text
                                    text="Legal Noticies"
                                    tag="h3"
                                    key={getKey(report, '84_83')}
                                  />
                                  <Text
                                    text={b.tryCatch(textFn5, props, vars)}
                                    tag="p"
                                    key={getKey(report, '84_84')}
                                  />
                                  <Text
                                    text="If a stipend is offered for the externship, please note that it is not a wage or salary and does not signify employment. As such, there are no conflicts for international students with CPT/OPT either."
                                    tag="p"
                                    key={getKey(report, '84_148')}
                                  />
                                  <Text
                                    text="This program is fully remote and students can participate from anywhere in the world. Due to the educational nature of this experience, work authorization for the US is not required."
                                    tag="p"
                                    key={getKey(report, '84_149')}
                                  />
                                  <Text
                                    text="Failure to complete or withdrawal from a program may make the extern ineligible from consideration in future externships."
                                    tag="p"
                                    className={styles.clt_84_152}
                                    key={getKey(report, '84_152')}
                                  />
                                </Box>
                                <Box
                                  tag="div"
                                  className={styles.clt_84_155}
                                  key={getKey(report, '84_155')}
                                >
                                  <Text
                                    text="Next Steps"
                                    tag="h3"
                                    key={getKey(report, '84_156')}
                                  />
                                  <Text
                                    text={b.tryCatch(textFn6, props, vars)}
                                    tag="p"
                                    key={getKey(report, '84_157')}
                                  />
                                  <Text
                                    text={b.tryCatch(textFn7, props, vars)}
                                    tag="p"
                                    key={getKey(report, '84_158')}
                                  />
                                  <Text
                                    text={b.tryCatch(textFn8, props, vars)}
                                    tag="p"
                                    key={getKey(report, '84_159')}
                                  />
                                  <Text
                                    text={b.tryCatch(textFn9, props, vars)}
                                    tag="p"
                                    key={getKey(report, '84_164')}
                                  />
                                  <Text
                                    text={b.tryCatch(textFn10, props, vars)}
                                    tag="p"
                                    key={getKey(report, '84_166')}
                                  />
                                  <Text
                                    text="By accepting your offer, you’re acknowledging that you’ve reviewed this policy. Acceptance of this offer followed by posting the experience on LinkedIn will result in our Extern team asking you to remove the experience from your account."
                                    tag="p"
                                    key={getKey(report, '84_168')}
                                  />
                                  <Text
                                    text="Upon successful completion, we’ll share with you how you list the experience on your resume and LinkedIn. We’ll also deliver to you any other credentials and opportunities you’ve earned as well."
                                    tag="p"
                                    key={getKey(report, '84_170')}
                                  />
                                  <Text
                                    text="With that understood, accept your offer below to move forward. Congratulations again!"
                                    tag="p"
                                    key={getKey(report, '84_172')}
                                  />
                                </Box>
                              </Box>
                            </Box>
                            {getKey(report, '206_420', null, '__CLUTCH_IF__') &&
                            b.tryCatch(conditionFn6, props, vars) ? (
                              <Box
                                tag="div"
                                className={styles.clt_74_0}
                                key={getKey(report, '74_0')}
                              >
                                <UseState
                                  initialValue={b.tryCatch(
                                    initialValueFn,
                                    props,
                                    vars
                                  )}
                                  key={getKey(report, '89_95')}
                                >
                                  {(
                                    (prevReport) =>
                                    (...args) => {
                                      const [report, vars] = b.getReport(
                                        '89_95',
                                        'children',
                                        prevReport,
                                        'usestatecurrentform',
                                        args
                                      );

                                      return (
                                        <Box
                                          tag="div"
                                          className={styles.clt_74_1}
                                          key={getKey(report, '74_1')}
                                        >
                                          <Box
                                            tag="div"
                                            className={styles.clt_74_2}
                                            key={getKey(report, '74_2')}
                                          >
                                            <Box
                                              tag="div"
                                              className={styles.clt_75_23}
                                              key={getKey(report, '75_23')}
                                            >
                                              <HTMLElement
                                                tag="div"
                                                innerHTML={
                                                  '<svg width="377" height="318" viewBox="0 0 377 318" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M176.939 246.185C176.939 246.185 174.719 247.346 173.709 247.879C168.885 251.347 159.088 241.43 155.072 236.894C155.017 236.832 154.944 236.787 154.862 236.767C154.781 236.746 154.696 236.75 154.617 236.779C154.538 236.807 154.47 236.859 154.42 236.926C154.371 236.994 154.343 237.075 154.34 237.159C154.465 240.297 155.352 243.359 156.924 246.078C161.695 255.001 161.877 275.973 166.47 278.817C166.749 278.994 167.063 279.107 167.391 279.149C167.718 279.191 168.051 279.161 168.366 279.061C169.52 278.721 171.092 276.226 173.994 260.298C174.89 255.691 176.071 251.144 177.528 246.682C177.551 246.604 177.552 246.52 177.529 246.442C177.505 246.363 177.46 246.293 177.397 246.24C177.334 246.188 177.258 246.154 177.177 246.144C177.095 246.134 177.013 246.149 176.939 246.185Z" fill="#061237"/>\n<path d="M296.63 138.237C295.455 138.005 294.245 138.018 293.075 138.274C291.905 138.531 290.8 139.025 289.829 139.727C288.859 140.429 288.043 141.323 287.433 142.354C286.823 143.385 286.431 144.53 286.283 145.718C286.277 145.824 286.311 145.929 286.379 146.011C286.447 146.092 286.543 146.145 286.648 146.159C286.754 146.172 286.86 146.145 286.947 146.083C287.033 146.021 287.092 145.929 287.113 145.825C287.346 144.022 288.192 142.355 289.508 141.101C290.824 139.848 292.531 139.084 294.342 138.939C296.154 138.794 297.961 139.276 299.46 140.304C300.958 141.332 302.058 142.844 302.576 144.586C302.611 144.688 302.685 144.771 302.78 144.82C302.876 144.869 302.987 144.879 303.09 144.849C303.193 144.818 303.281 144.749 303.334 144.656C303.388 144.563 303.404 144.453 303.379 144.349C302.937 142.802 302.07 141.409 300.878 140.329C299.685 139.249 298.214 138.524 296.63 138.237Z" fill="#061237"/>\n<path d="M321.619 124.071C319.912 123.477 318.063 123.425 316.325 123.922C314.588 124.419 313.046 125.44 311.911 126.847C310.775 128.253 310.102 129.976 309.983 131.779C309.864 133.583 310.305 135.379 311.245 136.922C311.654 137.591 312.152 138.202 312.726 138.736C312.766 138.774 312.813 138.803 312.864 138.822C312.916 138.841 312.97 138.85 313.025 138.848C313.08 138.847 313.134 138.834 313.184 138.811C313.234 138.789 313.279 138.756 313.316 138.716C313.354 138.676 313.383 138.629 313.402 138.578C313.421 138.526 313.43 138.472 313.429 138.417C313.427 138.362 313.414 138.308 313.391 138.258C313.369 138.208 313.336 138.163 313.296 138.126C311.977 136.88 311.124 135.219 310.881 133.421C310.637 131.622 311.018 129.795 311.958 128.243C312.899 126.691 314.344 125.509 316.051 124.893C317.758 124.277 319.624 124.265 321.339 124.859C321.444 124.896 321.559 124.89 321.659 124.842C321.759 124.795 321.836 124.709 321.873 124.605C321.91 124.5 321.904 124.385 321.857 124.285C321.809 124.185 321.724 124.108 321.619 124.071Z" fill="#061237"/>\n<path d="M338.547 112.021C335.439 106.961 329.201 105.609 327.42 106.633C325.364 107.812 315.392 114.108 262.037 146.566C261.949 146.627 261.887 146.719 261.865 146.823C261.842 146.928 261.861 147.037 261.916 147.128C261.971 147.22 262.059 147.287 262.162 147.316C262.265 147.344 262.375 147.333 262.47 147.283L266.945 144.566C265.76 146.863 265.397 149.497 265.918 152.029C266.439 154.561 267.812 156.838 269.807 158.481C271.803 160.123 274.302 161.033 276.886 161.057C279.471 161.081 281.986 160.219 284.013 158.614C284.821 160.877 286.33 162.823 288.32 164.169C290.31 165.515 292.677 166.192 295.078 166.102C297.479 166.011 299.789 165.157 301.671 163.664C303.554 162.171 304.911 160.117 305.547 157.799C307.339 159.013 309.443 159.687 311.607 159.742C313.771 159.796 315.906 159.229 317.758 158.108C319.61 156.986 321.101 155.357 322.055 153.414C323.01 151.471 323.387 149.295 323.142 147.143C325.49 147.588 327.917 147.278 330.078 146.259C332.238 145.239 334.021 143.563 335.171 141.469C336.321 139.375 336.779 136.971 336.48 134.601C336.181 132.231 335.139 130.016 333.505 128.273C334.976 127.617 336.29 126.655 337.359 125.45C338.428 124.246 339.228 122.827 339.705 121.289C340.183 119.75 340.326 118.128 340.126 116.53C339.926 114.931 339.388 113.394 338.547 112.021ZM338.813 121.316C338.317 122.775 337.504 124.106 336.433 125.214C335.362 126.322 334.059 127.18 332.617 127.725C331.184 128.26 329.665 128.532 328.135 128.527C328.024 128.526 327.917 128.567 327.835 128.641C327.753 128.716 327.702 128.818 327.691 128.928C327.687 128.984 327.694 129.04 327.713 129.093C327.731 129.145 327.759 129.194 327.797 129.235C327.834 129.277 327.879 129.31 327.93 129.334C327.98 129.357 328.035 129.37 328.091 129.372C329.644 129.388 331.189 129.13 332.653 128.609C333.778 129.726 334.634 131.085 335.158 132.581C335.681 134.078 335.858 135.674 335.674 137.25C335.49 138.825 334.951 140.337 334.098 141.674C333.244 143.01 332.098 144.135 330.746 144.963C329.578 145.699 328.272 146.189 326.909 146.403C325.545 146.616 324.153 146.55 322.816 146.207C321.48 145.844 320.217 145.252 319.082 144.459C318.993 144.407 318.888 144.389 318.787 144.409C318.686 144.429 318.596 144.486 318.534 144.568C318.472 144.651 318.442 144.753 318.451 144.856C318.459 144.959 318.505 145.055 318.58 145.126C319.701 145.909 320.94 146.508 322.25 146.901C322.555 148.941 322.251 151.026 321.376 152.894C320.5 154.761 319.093 156.329 317.33 157.399C315.567 158.469 313.527 158.995 311.466 158.91C309.405 158.825 307.415 158.133 305.746 156.92C306.008 155.454 306.036 153.956 305.831 152.48C305.814 152.371 305.754 152.272 305.665 152.207C305.576 152.141 305.464 152.114 305.354 152.131C305.245 152.148 305.147 152.207 305.081 152.296C305.015 152.386 304.988 152.497 305.005 152.607C305.375 154.458 305.242 156.374 304.621 158.157C304 159.94 302.913 161.524 301.473 162.744C300.033 163.965 298.293 164.778 296.433 165.099C294.572 165.419 292.66 165.236 290.895 164.568C289.429 164.012 288.108 163.131 287.032 161.991C285.955 160.852 285.151 159.483 284.679 157.988C285.541 157.093 286.286 156.093 286.899 155.011C286.952 154.914 286.964 154.799 286.932 154.693C286.901 154.586 286.828 154.497 286.731 154.444C286.633 154.391 286.519 154.379 286.413 154.41C286.306 154.442 286.217 154.514 286.164 154.612C285.198 156.551 283.636 158.131 281.707 159.119C279.779 160.107 277.584 160.451 275.446 160.102C273.689 159.84 272.027 159.136 270.617 158.056C269.206 156.976 268.094 155.555 267.384 153.927C266.673 152.299 266.389 150.517 266.556 148.749C266.724 146.98 267.338 145.284 268.342 143.818C268.535 143.534 326.166 108.469 327.493 107.647C331.005 105.492 342.043 111.852 338.813 121.32V121.316Z" fill="#061237"/>\n<path d="M323.555 87.5593C322.713 86.1874 321.589 85.0107 320.256 84.1079C318.923 83.2051 317.413 82.5968 315.827 82.3237C314.24 82.0506 312.614 82.1189 311.056 82.524C309.498 82.9292 308.045 83.6619 306.792 84.6733C306.227 83.0895 305.315 81.6517 304.123 80.465C302.931 79.2782 301.49 78.3722 299.903 77.813C298.317 77.2539 296.626 77.0557 294.954 77.2328C293.281 77.4099 291.669 77.958 290.235 78.8369C287.834 80.3206 286.066 82.6397 285.272 85.3482C283.468 84.1466 281.357 83.4888 279.189 83.4531C277.022 83.4174 274.891 84.0054 273.048 85.1469C271.206 86.2885 269.73 87.9356 268.798 89.892C267.865 91.8484 267.514 94.0317 267.787 96.1818C265.434 95.6981 262.989 95.9766 260.805 96.977C258.621 97.9773 256.813 99.6475 255.643 101.745C254.473 103.843 254.002 106.258 254.297 108.642C254.593 111.026 255.641 113.253 257.288 115.001C254.942 116.077 253.035 117.924 251.883 120.234C250.731 122.545 250.405 125.18 250.958 127.701C251.511 130.223 252.91 132.479 254.922 134.096C256.935 135.713 259.44 136.592 262.022 136.588L257.637 139.252C257.542 139.311 257.475 139.405 257.449 139.514C257.424 139.622 257.443 139.737 257.502 139.831C257.56 139.926 257.655 139.994 257.763 140.019C257.872 140.045 257.986 140.026 258.081 139.967C287.558 122.051 323.629 99.7849 323.851 99.4119C324.863 97.5895 325.369 95.5294 325.317 93.4454C325.266 91.3613 324.657 89.3291 323.555 87.5593ZM323.111 99.0012C322.983 99.2232 291.019 118.477 263.837 135.485C263.691 135.581 263.525 135.645 263.351 135.671C260.865 135.997 258.343 135.42 256.246 134.044C254.149 132.669 252.616 130.586 251.924 128.175C251.233 125.764 251.43 123.185 252.479 120.907C253.528 118.63 255.36 116.804 257.641 115.762C258.986 115.254 260.403 114.965 261.839 114.908C261.945 114.9 262.044 114.852 262.116 114.775C262.188 114.697 262.229 114.595 262.229 114.489C262.229 114.383 262.188 114.281 262.116 114.203C262.044 114.126 261.945 114.078 261.839 114.071C260.594 114.123 259.36 114.333 258.168 114.697C257.04 113.58 256.182 112.222 255.656 110.725C255.131 109.228 254.953 107.631 255.136 106.055C255.318 104.479 255.857 102.965 256.71 101.627C257.564 100.29 258.711 99.1643 260.063 98.3352C261.922 97.2244 264.07 96.6966 266.232 96.8201C268.393 96.9435 270.467 97.7126 272.187 99.0279C272.277 99.0926 272.389 99.1189 272.499 99.101C272.608 99.0831 272.706 99.0225 272.771 98.9324C272.836 98.8423 272.862 98.7302 272.844 98.6207C272.826 98.5112 272.765 98.4133 272.675 98.3485C271.454 97.4956 270.105 96.8407 268.679 96.4083C268.356 94.3697 268.642 92.281 269.502 90.4047C270.362 88.5283 271.757 86.9481 273.513 85.8625C275.268 84.7769 277.306 84.2345 279.369 84.3033C281.432 84.3722 283.428 85.0493 285.107 86.2495C284.862 87.5958 284.835 88.9728 285.027 90.3277C285.052 90.4317 285.115 90.5226 285.204 90.5818C285.293 90.641 285.401 90.6641 285.506 90.6462C285.611 90.6284 285.706 90.571 285.771 90.4858C285.835 90.4006 285.865 90.294 285.853 90.1878C285.422 87.5812 285.993 84.9081 287.452 82.7053C288.911 80.5026 291.149 78.9334 293.717 78.3131C296.285 77.6927 298.993 78.067 301.297 79.3609C303.6 80.6548 305.329 82.7724 306.135 85.2883C305.012 86.3598 304.081 87.617 303.385 89.0046C303.203 89.4064 303.76 90.1145 304.33 89.0201C304.976 87.7732 305.845 86.6557 306.894 85.7234C308.036 84.6863 309.392 83.9139 310.866 83.4612C312.34 83.0085 313.896 82.8867 315.423 83.1045C316.949 83.3222 318.409 83.8742 319.698 84.721C320.987 85.5678 322.073 86.6885 322.878 88.0033C323.879 89.6547 324.428 91.5404 324.469 93.471C324.51 95.4016 324.042 97.3089 323.111 99.0012Z" fill="#061237"/>\n<path d="M278.789 104.23C278.707 104.163 278.603 104.129 278.497 104.136C278.391 104.142 278.292 104.188 278.219 104.265C278.145 104.342 278.104 104.443 278.103 104.549C278.102 104.655 278.14 104.758 278.212 104.836C279.531 106.088 280.38 107.754 280.616 109.557C280.853 111.36 280.462 113.189 279.51 114.738C278.559 116.287 277.103 117.462 275.389 118.066C273.674 118.669 271.803 118.665 270.091 118.054C269.989 118.026 269.88 118.037 269.785 118.086C269.691 118.135 269.619 118.217 269.583 118.317C269.547 118.417 269.551 118.527 269.593 118.624C269.635 118.722 269.712 118.8 269.809 118.842C271.702 119.518 273.77 119.523 275.666 118.856C277.562 118.188 279.171 116.89 280.223 115.177C281.276 113.465 281.707 111.442 281.446 109.449C281.185 107.456 280.247 105.614 278.789 104.23Z" fill="#061237"/>\n<path d="M304.305 97.0682C304.056 98.8655 303.198 100.523 301.875 101.765C300.551 103.006 298.843 103.756 297.033 103.891C295.224 104.025 293.423 103.535 291.931 102.502C290.439 101.47 289.346 99.9568 288.834 98.216C288.803 98.1094 288.731 98.0195 288.634 97.966C288.537 97.9125 288.422 97.8998 288.316 97.9307C288.209 97.9616 288.119 98.0336 288.066 98.1308C288.012 98.228 287.999 98.3425 288.03 98.4491C288.594 100.374 289.801 102.048 291.45 103.19C293.099 104.332 295.09 104.874 297.091 104.726C299.091 104.577 300.98 103.747 302.442 102.373C303.904 101 304.851 99.1665 305.124 97.1792C305.124 97.0786 305.087 96.9814 305.021 96.9058C304.954 96.8301 304.863 96.781 304.763 96.7675C304.663 96.7539 304.562 96.7769 304.478 96.8322C304.394 96.8875 304.332 96.9713 304.305 97.0682Z" fill="#061237"/>\n<path d="M365.147 78.3098C337.472 30.7396 272.837 24.1973 237.994 66.566C228.943 80.294 218.763 93.243 207.56 105.278C207.522 105.318 207.493 105.365 207.473 105.417C207.454 105.468 207.445 105.522 207.446 105.577C207.448 105.632 207.461 105.686 207.483 105.736C207.506 105.786 207.538 105.831 207.578 105.869C207.618 105.906 207.665 105.936 207.716 105.955C207.767 105.975 207.822 105.984 207.877 105.982C207.931 105.981 207.985 105.968 208.035 105.946C208.085 105.923 208.131 105.891 208.168 105.851C219.407 93.8046 229.614 80.8356 238.682 67.081C238.701 67.0543 238.716 67.0252 238.726 66.9944C273.03 25.4405 336.899 31.4212 364.421 78.7205C391.873 125.909 367.009 187.028 315.339 198.705C298.088 200.868 281.006 204.206 264.21 208.695C264.108 208.728 264.023 208.8 263.972 208.894C263.922 208.989 263.91 209.099 263.938 209.202C263.967 209.306 264.034 209.394 264.126 209.449C264.218 209.504 264.327 209.522 264.432 209.498C281.058 204.819 298.035 201.491 315.197 199.546C315.255 199.558 315.316 199.558 315.374 199.546C367.777 187.829 392.866 125.96 365.147 78.3098Z" fill="#061237"/>\n<path d="M274.736 17.7832C260.972 27.3292 235.835 42.7116 206.291 47.398C204.027 47.7599 201.234 47.2359 199.514 48.7744C194.077 53.634 192.958 70.5903 179.534 70.9589C177.665 75.6697 175.982 80.2385 174.159 84.1323C174.799 83.2443 176.981 82.8003 180.167 82.7737C185.683 82.8938 191.172 83.6007 196.539 84.8827C205.468 86.8807 212.878 89.7156 215.795 92.0422C216.765 92.8148 217.241 93.5363 217.098 94.1512C220.138 87.6133 218.95 80.9711 216.952 74.058C241.043 69.4071 274.421 52.3819 290.434 38.3759C289.162 30.3617 282.071 21.9191 274.736 17.7832Z" fill="#0135FF"/>\n<path d="M232.158 220.256C232.136 220.205 232.106 220.16 232.067 220.121C232.028 220.083 231.982 220.053 231.932 220.032C231.881 220.011 231.827 220.001 231.772 220.001C231.718 220.001 231.664 220.012 231.614 220.034C212.819 227.695 194.389 237.085 175.623 246.878C177.13 244.067 177.075 239.039 175.401 232.279C172.965 223.3 169.441 214.652 164.907 206.527L231.556 166.063C231.651 166.004 231.719 165.91 231.744 165.801C231.77 165.692 231.751 165.578 231.692 165.483C231.634 165.388 231.539 165.32 231.43 165.294C231.322 165.269 231.207 165.287 231.112 165.346L164.516 205.777C163.244 203.452 161.99 201.292 160.696 199.175L230.237 156.899C230.332 156.84 230.4 156.746 230.426 156.637C230.451 156.528 230.433 156.414 230.374 156.319C230.315 156.223 230.221 156.156 230.112 156.13C230.003 156.104 229.888 156.123 229.793 156.182L160.258 198.462C155.532 190.573 149.867 183.286 143.386 176.761C138.154 171.731 133.676 169.156 130.453 169.267C148.435 156 162.942 145.655 176.678 134.635C176.759 134.563 176.809 134.463 176.818 134.356C176.827 134.248 176.794 134.141 176.727 134.057C176.659 133.973 176.561 133.918 176.454 133.904C176.347 133.89 176.238 133.918 176.151 133.982C157.452 148.996 129.161 168.872 128.155 169.946C121.781 173.902 126.668 194.088 139.359 216.086C150.757 235.844 164.039 249.422 171.418 249.422C172.406 249.445 173.375 249.149 174.182 248.578C229.649 219.59 232.713 221.608 232.158 220.256Z" fill="#061237"/>\n<path d="M58.0432 316.865L70.4752 309.621C70.5707 309.573 70.681 309.563 70.7835 309.593C70.8861 309.624 70.9732 309.692 71.027 309.784C71.0809 309.877 71.0974 309.986 71.0733 310.091C71.0491 310.195 70.9861 310.286 70.897 310.345C60.7916 316.226 58.8846 317.378 58.4362 317.598C58.3403 317.639 58.2326 317.642 58.1344 317.607C58.0361 317.573 57.9543 317.503 57.905 317.411C57.8558 317.319 57.8427 317.212 57.8682 317.111C57.8938 317.01 57.9562 316.922 58.0432 316.865Z" fill="#061237"/>\n<path d="M9.84459 239.611C9.75205 239.612 9.66196 239.582 9.58848 239.525C9.51499 239.469 9.46229 239.39 9.43865 239.301C9.41501 239.211 9.42178 239.116 9.45789 239.031C9.494 238.946 9.5574 238.875 9.63813 238.83L22.361 231.601C22.4572 231.547 22.5713 231.532 22.6781 231.562C22.7849 231.591 22.8756 231.662 22.9304 231.758C22.9851 231.854 22.9994 231.968 22.9701 232.075C22.9407 232.182 22.8701 232.273 22.7739 232.327C9.38505 239.922 10.0666 239.611 9.84459 239.611Z" fill="#061237"/>\n<path d="M141.482 247.27C135.539 229.531 126.132 213.15 113.807 199.076C106.73 191.35 101.293 186.085 95.8431 188.658C92.542 190.469 91.7228 193.033 92.2778 196.816C91.3362 195.633 90.0235 194.803 88.5517 194.458C87.0798 194.113 85.5348 194.275 84.166 194.916C82.7972 195.558 81.6846 196.642 81.0079 197.994C80.3312 199.345 80.1298 200.886 80.4363 202.366C79.3576 201.485 78.0317 200.961 76.6422 200.867C75.2527 200.773 73.8683 201.113 72.6806 201.841C71.493 202.568 70.5609 203.647 70.0134 204.927C69.466 206.208 69.3302 207.627 69.6249 208.988C68.607 208.159 67.3656 207.65 66.0582 207.527C64.7508 207.403 63.4362 207.671 62.2811 208.296C41.0357 220.075 57.2284 211.295 31.0235 226.175C30.9273 226.231 30.8568 226.322 30.8277 226.429C30.7985 226.536 30.8131 226.65 30.8681 226.746C30.9232 226.842 31.0142 226.913 31.1212 226.942C31.2282 226.971 31.3424 226.957 31.4387 226.901L48.3662 217.284C45.0095 223.916 50.1666 242.013 61.4065 261.598L20.867 285.525C20.7717 285.582 20.7026 285.674 20.6752 285.781C20.6477 285.888 20.664 286.002 20.7205 286.098C20.777 286.193 20.8691 286.262 20.9765 286.29C21.084 286.317 21.1979 286.301 21.2933 286.244L61.8172 262.33C73.1392 281.822 86.2549 295.364 93.6675 295.737L78.5893 304.519C78.5002 304.579 78.4372 304.67 78.413 304.774C78.3889 304.878 78.4054 304.987 78.4593 305.08C78.5131 305.172 78.6002 305.241 78.7028 305.271C78.8053 305.301 78.9156 305.291 79.0111 305.243L109.227 287.681C110.215 286.897 110.965 285.854 111.391 284.668C111.818 283.482 111.905 282.2 111.643 280.967C112.723 281.831 114.044 282.34 115.425 282.425C116.805 282.51 118.178 282.166 119.357 281.442C120.535 280.717 121.461 279.646 122.007 278.376C122.554 277.105 122.696 275.697 122.412 274.343C123.26 275.018 124.255 275.483 125.317 275.699C126.379 275.915 127.477 275.878 128.521 275.588C129.384 275.333 130.188 274.907 130.884 274.337C131.58 273.766 132.155 273.063 132.576 272.267C132.996 271.471 133.253 270.599 133.332 269.703C133.411 268.806 133.31 267.903 133.035 267.046C134.211 267.917 135.613 268.433 137.073 268.532C138.534 268.631 139.992 268.309 141.275 267.605C146.694 264.18 144.623 257.453 141.482 247.27ZM140.836 266.897C139.375 267.643 137.7 267.857 136.099 267.502C134.497 267.147 133.069 266.245 132.06 264.952C131.996 264.868 131.902 264.81 131.798 264.792C131.693 264.775 131.586 264.797 131.497 264.856C131.408 264.914 131.346 265.004 131.321 265.108C131.297 265.211 131.312 265.32 131.365 265.412C131.936 266.223 132.309 267.157 132.453 268.138C132.598 269.119 132.51 270.12 132.198 271.062C131.893 271.949 131.38 272.75 130.702 273.397C130.024 274.045 129.2 274.52 128.299 274.782C127.088 275.123 125.8 275.07 124.621 274.631C123.442 274.192 122.433 273.39 121.739 272.34C121.335 271.688 120.609 272.26 120.885 272.716C121.705 274.04 121.965 275.637 121.608 277.153C121.252 278.67 120.307 279.983 118.982 280.803C117.657 281.623 116.061 281.884 114.544 281.527C113.028 281.17 111.715 280.225 110.895 278.9C110.484 278.485 109.858 278.943 110.124 279.387C110.855 280.61 111.116 282.057 110.859 283.459C110.602 284.86 109.845 286.121 108.728 287.006L98.1874 293.109C104.268 281.078 82.5142 236.754 62.5453 219.682C59.999 217.553 56.2139 214.831 52.915 214.654L62.6829 209.039C64.0076 208.337 65.5511 208.168 66.9962 208.568C68.4413 208.968 69.6782 209.907 70.4529 211.19C70.521 211.285 70.6224 211.35 70.7365 211.372C70.8507 211.394 70.969 211.372 71.0674 211.31C71.1658 211.248 71.2369 211.151 71.2663 211.038C71.2957 210.926 71.2811 210.806 71.2255 210.704C70.4068 209.394 70.1377 207.813 70.4767 206.305C70.8157 204.798 71.7354 203.484 73.0363 202.65C74.3373 201.816 75.9146 201.528 77.4262 201.85C78.9378 202.171 80.2619 203.075 81.1112 204.366C81.4042 204.81 82.3189 204.562 81.9992 204.024C81.5226 203.252 81.2342 202.378 81.1571 201.474C81.08 200.57 81.2163 199.66 81.5552 198.818C81.9713 197.757 82.688 196.84 83.6174 196.18C84.5469 195.52 85.6488 195.146 86.7879 195.102C87.9271 195.059 89.0541 195.349 90.0308 195.937C91.0075 196.525 91.7915 197.385 92.2867 198.412C92.3355 198.497 92.5819 198.927 92.7307 199.171C93.097 199.775 93.6053 199.371 93.5498 198.965C92.5508 194.578 92.3999 191.501 96.2138 189.408C101.133 187.097 106.579 192.429 113.188 199.642C125.433 213.623 134.778 229.896 140.68 247.519C143.817 257.679 145.704 263.816 140.836 266.897Z" fill="#061237"/>\n<path d="M0.520645 298.651C0.428664 298.65 0.339337 298.62 0.266411 298.564C0.193485 298.508 0.141 298.429 0.117033 298.34C0.0930657 298.251 0.0989447 298.157 0.133765 298.072C0.168585 297.987 0.230416 297.916 0.309745 297.869L12.7417 290.625C12.8372 290.577 12.9475 290.567 13.05 290.597C13.1526 290.628 13.2397 290.696 13.2935 290.788C13.3474 290.881 13.3639 290.99 13.3398 291.094C13.3156 291.199 13.2526 291.29 13.1635 291.349C0.101066 298.946 0.742646 298.651 0.520645 298.651Z" fill="#061237"/>\n<path d="M313.989 0.438897C307.859 3.52506 301.577 6.29844 295.166 8.74836C295.936 7.4652 296.884 5.44943 295.932 4.48595C294.438 2.97191 278.822 16.5872 276.678 18.472C276.075 18.0624 275.447 17.6916 274.797 17.362C273.545 17.2354 244.865 40.8451 206.224 46.9745C205.752 47.0448 205.277 47.0893 204.801 47.1077C202.359 46.515 202.885 45.4982 202.137 43.4447C205.087 42.963 209.612 41.9152 210.555 39.9238C213.033 34.6979 206.368 20.7697 203.704 14.4604C200.288 6.36851 181.14 10.1447 165.52 17.7171C152.44 24.0597 141.837 33.064 145.016 39.9904C146.648 43.5424 151.898 44.9299 159.475 43.9265C152.148 46.8308 145.567 51.3433 140.217 57.131C118.756 81.773 161.529 85.0498 186.67 55.1197C183.108 61.2194 180.126 67.6396 177.763 74.2961C174.329 83.1073 173.632 84.1218 173.568 84.4037C173.181 86.142 176.232 87.8558 177.817 88.6661C176.727 91.0332 175.095 93.1102 173.053 94.729C156.647 107.767 155.83 126.226 167.975 140.383L168.641 139.873C156.804 126.109 157.501 108.16 173.576 95.3861C174.79 94.424 175.87 93.3041 176.787 92.0561C188.567 91.8952 200.169 94.9417 210.351 100.869C209.578 102.113 208.706 103.482 207.716 105.014C204.71 103.562 201.629 102.143 198.474 100.756C198.374 100.721 198.264 100.724 198.167 100.766C198.07 100.808 197.992 100.885 197.949 100.982C197.906 101.079 197.902 101.189 197.937 101.289C197.971 101.389 198.043 101.472 198.136 101.522C217.679 109.832 235.919 120.92 252.293 134.443C256.215 137.758 259.386 141.872 261.594 146.509C263.802 151.146 264.996 156.201 265.098 161.336C265.405 175.837 264.978 191.949 263.722 212.227C253.439 214.574 242.709 214.044 232.708 210.693C232.993 197.595 232.486 184.859 232 171.641C236.607 158.476 236.44 159.053 236.44 158.829C236.437 158.761 236.416 158.695 236.38 158.637C236.344 158.579 236.294 158.531 236.234 158.498C236.136 158.447 231.403 156.689 231.301 156.649C230.539 156.318 199.484 142.794 181.677 137.186C176.349 135.51 171.909 129.004 170.631 120.996C170.609 120.89 170.547 120.797 170.459 120.735C170.37 120.673 170.261 120.648 170.154 120.665C170.047 120.682 169.951 120.74 169.885 120.826C169.82 120.912 169.79 121.02 169.802 121.127C171.134 129.441 175.796 136.223 181.426 137.986C198.478 143.356 227.747 156.016 230.733 157.315C231.046 174.276 232.287 192.056 231.858 210.942C231.855 210.97 231.855 210.999 231.858 211.028C231.485 227.367 230.553 227.805 231.268 228.082C232.555 228.577 233.812 229.012 235.017 229.376C235.142 236.132 233.004 239.733 234.84 244.126C235.933 246.625 237.508 248.883 239.475 250.773C247.551 258.913 254.127 282.832 259.899 279.089C260.907 278.423 261.695 275.59 259.899 259.504C259.145 249.603 259.256 239.655 260.23 229.774C261.2 229.49 262.186 229.163 263.167 228.797C263.242 228.769 263.308 228.72 263.356 228.656C263.404 228.592 263.432 228.515 263.438 228.435C265.542 200.199 266.308 179.497 265.924 161.316C265.819 156.063 264.597 150.892 262.339 146.148C260.08 141.405 256.838 137.196 252.826 133.803C239.275 122.536 224.379 112.993 208.479 105.392C210.333 102.519 212.509 99.0846 214.176 96.0832C216.147 95.7879 217.262 95.1841 217.493 94.2894C220.379 88.0734 219.59 81.813 217.479 74.3804C242.59 69.401 275.53 51.9584 290.701 38.6895C290.755 38.6426 290.795 38.583 290.819 38.5162C290.843 38.4495 290.85 38.3777 290.839 38.3077C290.685 37.3414 290.463 36.3873 290.173 35.4527C292.536 32.9449 295.205 30.7453 298.118 28.906C299.195 29.4925 300.402 29.798 301.628 29.794C305.691 29.794 309.534 26.4973 309.791 23.9443C309.843 23.3419 309.692 22.7395 309.363 22.2326C309.838 21.9533 310.248 21.5744 310.563 21.1218C310.879 20.6692 311.092 20.1538 311.19 19.6108C311.233 19.1277 311.152 18.6416 310.956 18.1982C310.759 17.7547 310.453 17.3685 310.066 17.0756C310.396 16.6321 310.583 16.0982 310.6 15.5458C310.618 14.9933 310.465 14.4488 310.164 13.9853C309.38 13.07 308.407 12.3357 307.311 11.8332C306.216 11.3307 305.025 11.072 303.819 11.0749C311.776 6.91464 315.177 2.28816 315.246 0.965036C315.275 0.390056 314.786 -0.0228629 313.989 0.438897ZM262.63 228.093C252.639 231.658 241.685 231.412 231.865 227.403C232.309 222.053 232.557 216.773 232.684 211.556C242.681 214.862 253.388 215.391 263.662 213.086C263.364 217.85 263.02 222.841 262.63 228.093ZM295.392 5.14308C295.941 5.94006 294.398 8.53302 293.838 9.25674C289.853 10.5592 286.041 12.3408 282.485 14.5625C287.762 10.1758 294.171 5.2674 295.392 5.14308ZM188.435 53.972C193.226 46.9102 195.614 37.2443 196.773 28.8238C196.783 28.7531 196.775 28.6809 196.749 28.6144C196.723 28.5478 196.68 28.4892 196.625 28.4442C191.032 23.8532 194.034 19.875 197.044 22.9408C199.027 24.961 201.766 24.1663 199.459 17.7061C200.797 17.1217 202.084 16.4274 203.307 15.6304C209.028 29.0125 211.017 35.5438 210.1 38.745C209.19 41.9085 201.333 38.0501 198.394 36.525C198.318 36.4863 198.233 36.4714 198.149 36.4822C198.065 36.493 197.986 36.529 197.923 36.5855C197.86 36.642 197.815 36.7163 197.795 36.7986C197.775 36.8809 197.78 36.9674 197.81 37.0467C198.594 39.3133 199.739 41.4385 201.2 43.3404C201.906 44.9721 201.662 46.2952 202.903 47.2099C201.574 47.2035 200.282 47.6445 199.235 48.4619C193.734 53.3748 192.731 69.6185 180.163 70.5065C182.322 64.7154 185.095 59.1723 188.435 53.972ZM210.795 100.168C200.653 94.2461 189.105 91.1613 177.362 91.2369C178.883 88.7639 179.947 86.0372 180.503 83.1872C190.162 83.1872 209.025 87.5317 215.27 92.1649C213.918 94.9084 212.424 97.5797 210.795 100.168ZM209.891 74.6602C209.785 74.6711 209.686 74.7224 209.616 74.8035C209.546 74.8846 209.51 74.9894 209.515 75.0965C209.52 75.2035 209.565 75.3046 209.642 75.3791C209.719 75.4536 209.822 75.4958 209.929 75.4971H209.967C212.007 75.3106 214.256 74.9887 216.656 74.5403C218.609 81.4001 219.415 87.2143 217.184 92.8841C214.698 89.0569 201.122 85.4804 196.631 84.4748C191.05 83.1192 185.331 82.4108 179.588 82.3636C178.08 82.3393 176.578 82.5543 175.137 83.0007C176.691 79.5175 178.145 75.6125 179.824 71.3679C193.243 70.7663 194.549 53.7722 199.804 49.088C201.384 47.6694 204.113 48.1778 206.366 47.8115C228.506 44.2994 251.518 34.3627 274.766 18.2855C281.73 22.297 288.608 30.1536 289.984 38.2211C272.384 53.5058 234.149 72.4535 209.891 74.6602ZM302.059 11.0239C300.992 11.0518 299.93 11.1887 298.891 11.4323C298.789 11.4637 298.703 11.5326 298.65 11.625C298.598 11.7174 298.582 11.8265 298.606 11.9301C298.631 12.0337 298.694 12.1241 298.783 12.1829C298.871 12.2418 298.979 12.2647 299.084 12.2471C304.785 10.9018 311.396 13.437 309.405 16.5605C307.915 15.7133 306.273 15.1683 304.572 14.9569C302.871 14.7455 301.145 14.8717 299.493 15.3284C299.439 15.341 299.389 15.3639 299.344 15.396C299.299 15.428 299.262 15.4686 299.233 15.5152C299.204 15.5619 299.184 15.6139 299.175 15.6681C299.166 15.7223 299.168 15.7778 299.181 15.8313C299.193 15.8848 299.216 15.9353 299.248 15.9799C299.28 16.0245 299.321 16.0624 299.368 16.0914C299.414 16.1203 299.466 16.1398 299.52 16.1487C299.575 16.1576 299.63 16.1557 299.684 16.1432C302.885 15.3884 307.296 15.6148 309.585 17.7638C309.844 17.9616 310.052 18.2201 310.188 18.5166C310.325 18.813 310.387 19.1384 310.368 19.4643C310.277 19.9038 310.095 20.3191 309.832 20.6833C309.57 21.0474 309.234 21.3522 308.846 21.5777C306.657 19.3466 302.345 19.2645 299.246 19.8905C299.142 19.9172 299.052 19.9829 298.995 20.0741C298.937 20.1652 298.918 20.2749 298.939 20.3804C298.96 20.4859 299.021 20.5791 299.11 20.6409C299.198 20.7026 299.306 20.728 299.413 20.7119C303.779 19.8239 306.763 20.8074 308.1 22.0195C308.379 22.2353 308.603 22.5147 308.753 22.8344C308.902 23.1541 308.974 23.5049 308.961 23.8577C308.684 24.7853 308.206 25.6407 307.562 26.3634C306.918 27.0861 306.123 27.6585 305.234 28.0402C304.283 28.5685 303.226 28.8747 302.141 28.9359C301.055 28.997 299.97 28.8114 298.967 28.3931C300.691 27.3387 302.537 26.4964 304.463 25.8845C304.569 25.8749 304.667 25.8255 304.738 25.7463C304.809 25.6671 304.847 25.564 304.845 25.4578C304.842 25.3516 304.8 25.2502 304.726 25.174C304.652 25.0979 304.552 25.0527 304.445 25.0476C298.84 26.8916 293.815 30.1722 289.871 34.5625C287.359 28.253 283.025 22.8346 277.421 18.9981C282.083 15.4454 287.245 12.6026 292.739 10.5621C300.104 7.83895 307.315 4.71747 314.34 1.21146C313.841 2.49684 310.477 6.95459 302.057 11.0239H302.059Z" fill="#061237"/>\n</svg>'
                                                }
                                                className={styles.clt_75_24}
                                                key={getKey(report, '75_24')}
                                                data-d={getKey(report, '75_24')}
                                              />
                                            </Box>
                                          </Box>
                                          <Box
                                            tag="div"
                                            className={styles.clt_74_3}
                                            key={getKey(report, '74_3')}
                                          >
                                            {getKey(
                                              report,
                                              '82_393',
                                              null,
                                              '__CLUTCH_IF__'
                                            ) &&
                                            b.tryCatch(
                                              conditionFn4,
                                              props,
                                              vars
                                            ) ? (
                                              <UseForm
                                                mode="all"
                                                defaultValues={{
                                                  offerID:
                                                    vars?.defaultUseParams2
                                                      ?.applicationID,
                                                  loginString:
                                                    vars?.defaultUseParams2
                                                      ?.loginString,
                                                }}
                                                key={getKey(
                                                  report,
                                                  'v200_103723'
                                                )}
                                              >
                                                {(
                                                  (prevReport) =>
                                                  (...args) => {
                                                    const [report, vars] =
                                                      b.getReport(
                                                        'v200_103723',
                                                        'children',
                                                        prevReport,
                                                        'useform2',
                                                        args
                                                      );

                                                    return [
                                                      <Text
                                                        text="Accept your offer and kickstart your career"
                                                        tag="h2"
                                                        className={
                                                          styles.clt_75_63
                                                        }
                                                        key={getKey(
                                                          report,
                                                          '75_63'
                                                        )}
                                                      />,
                                                      <Box
                                                        tag="div"
                                                        className={
                                                          styles.clt_75_203
                                                        }
                                                        key={getKey(
                                                          report,
                                                          '75_203'
                                                        )}
                                                      >
                                                        {getKey(
                                                          report,
                                                          '135_302',
                                                          null,
                                                          '__CLUTCH_LOOP__'
                                                        ) &&
                                                          b
                                                            .tryCatch(
                                                              itemsFn,
                                                              props,
                                                              vars
                                                            )
                                                            ?.map(
                                                              (
                                                                item,
                                                                index,
                                                                items
                                                              ) =>
                                                                (
                                                                  (
                                                                    prevReport
                                                                  ) =>
                                                                  (...args) => {
                                                                    const [
                                                                      report,
                                                                      vars,
                                                                    ] =
                                                                      b.getReport(
                                                                        '135_302',
                                                                        'children',
                                                                        prevReport,
                                                                        'loop',
                                                                        args
                                                                      );

                                                                    return (
                                                                      <Box
                                                                        tag="div"
                                                                        key={getKey(
                                                                          report,
                                                                          '75_208',
                                                                          vars
                                                                            ?.loop
                                                                            ?.item
                                                                            ?.label
                                                                        )}
                                                                      >
                                                                        <Icon
                                                                          name={
                                                                            vars
                                                                              ?.loop
                                                                              ?.item
                                                                              ?.icon
                                                                          }
                                                                          className={
                                                                            styles.clt_75_387
                                                                          }
                                                                          key={getKey(
                                                                            report,
                                                                            '75_387'
                                                                          )}
                                                                          data-d={getKey(
                                                                            report,
                                                                            '75_387'
                                                                          )}
                                                                        />
                                                                        <Text
                                                                          text={b.tryCatch(
                                                                            textFn11,
                                                                            props,
                                                                            vars
                                                                          )}
                                                                          tag="span"
                                                                          className={
                                                                            styles.clt_75_209
                                                                          }
                                                                          key={getKey(
                                                                            report,
                                                                            '75_209'
                                                                          )}
                                                                        />
                                                                        <Text
                                                                          text={
                                                                            vars
                                                                              ?.loop
                                                                              ?.item
                                                                              ?.value
                                                                          }
                                                                          tag="span"
                                                                          className={
                                                                            styles.clt_75_210
                                                                          }
                                                                          key={getKey(
                                                                            report,
                                                                            '75_210'
                                                                          )}
                                                                        />
                                                                      </Box>
                                                                    );
                                                                  }
                                                                )(report)?.({
                                                                  item,
                                                                  index,
                                                                  items,
                                                                })
                                                            )}
                                                      </Box>,
                                                      <TextField
                                                        placeholder="Sign your name here"
                                                        type="text"
                                                        register={b.tryCatch(
                                                          registerFn,
                                                          props,
                                                          vars
                                                        )}
                                                        className={
                                                          styles.clt_76_32
                                                        }
                                                        key={getKey(
                                                          report,
                                                          '76_32'
                                                        )}
                                                        data-d={getKey(
                                                          report,
                                                          '76_32'
                                                        )}
                                                      />,
                                                      <Box
                                                        tag="div"
                                                        className={
                                                          styles.clt_82_208
                                                        }
                                                        key={getKey(
                                                          report,
                                                          '82_208'
                                                        )}
                                                      >
                                                        <CheckboxField
                                                          label="I understand this is an unpaid educational opportunity"
                                                          required
                                                          register={b.tryCatch(
                                                            registerFn1,
                                                            props,
                                                            vars
                                                          )}
                                                          key={getKey(
                                                            report,
                                                            '82_28'
                                                          )}
                                                          data-d={getKey(
                                                            report,
                                                            '82_28'
                                                          )}
                                                        />
                                                        <CheckboxField
                                                          label="I understand this is NOT a guarantee of offer of a job"
                                                          required
                                                          register={b.tryCatch(
                                                            registerFn2,
                                                            props,
                                                            vars
                                                          )}
                                                          key={getKey(
                                                            report,
                                                            '82_222'
                                                          )}
                                                          data-d={getKey(
                                                            report,
                                                            '82_222'
                                                          )}
                                                        />
                                                        <CheckboxField
                                                          label="I'm interested in or require CPT to be able to participate in this experience"
                                                          required={false}
                                                          register={b.tryCatch(
                                                            registerFn3,
                                                            props,
                                                            vars
                                                          )}
                                                          key={getKey(
                                                            report,
                                                            '82_223'
                                                          )}
                                                          data-d={getKey(
                                                            report,
                                                            '82_223'
                                                          )}
                                                        />
                                                        <CheckboxField
                                                          label="I'm interested in receiving academic credit for the completion of this experience"
                                                          required={false}
                                                          register={b.tryCatch(
                                                            registerFn4,
                                                            props,
                                                            vars
                                                          )}
                                                          key={getKey(
                                                            report,
                                                            '82_224'
                                                          )}
                                                          data-d={getKey(
                                                            report,
                                                            '82_224'
                                                          )}
                                                        />
                                                      </Box>,
                                                      <Box
                                                        tag="div"
                                                        className={
                                                          styles.clt_82_239
                                                        }
                                                        key={getKey(
                                                          report,
                                                          '82_239'
                                                        )}
                                                      >
                                                        <Button
                                                          text="Accept Offer"
                                                          loading={b.tryCatch(
                                                            loadingFn,
                                                            props,
                                                            vars
                                                          )}
                                                          disabled={b.tryCatch(
                                                            disabledFn,
                                                            props,
                                                            vars
                                                          )}
                                                          rounded
                                                          size="medium"
                                                          color="info"
                                                          onClick={b.tryCatch(
                                                            onClickFn,
                                                            props,
                                                            vars
                                                          )}
                                                          key={getKey(
                                                            report,
                                                            '82_253'
                                                          )}
                                                          data-d={getKey(
                                                            report,
                                                            '82_253'
                                                          )}
                                                        />
                                                        <Box
                                                          tag="div"
                                                          className={
                                                            styles.clt_82_255
                                                          }
                                                          key={getKey(
                                                            report,
                                                            '82_255'
                                                          )}
                                                        >
                                                          <Element
                                                            tag="hr"
                                                            key={getKey(
                                                              report,
                                                              '82_256'
                                                            )}
                                                          />
                                                          <Text
                                                            text="or"
                                                            tag="span"
                                                            className={
                                                              styles.clt_82_259
                                                            }
                                                            key={getKey(
                                                              report,
                                                              '82_259'
                                                            )}
                                                          />
                                                          <Element
                                                            tag="hr"
                                                            key={getKey(
                                                              report,
                                                              '82_258'
                                                            )}
                                                          />
                                                        </Box>
                                                        <Button1
                                                          onClick={b.tryCatch(
                                                            onClickFn1,
                                                            props,
                                                            vars
                                                          )}
                                                          type="button"
                                                          disabled={false}
                                                          className={
                                                            styles.clt_82_370
                                                          }
                                                          key={getKey(
                                                            report,
                                                            '82_370'
                                                          )}
                                                        >
                                                          <Text
                                                            text="Decline Offer"
                                                            tag="span"
                                                            className={
                                                              styles.clt_82_343
                                                            }
                                                            key={getKey(
                                                              report,
                                                              '82_343'
                                                            )}
                                                          />
                                                        </Button1>
                                                      </Box>,
                                                    ];
                                                  }
                                                )(report)}
                                              </UseForm>
                                            ) : null}
                                            {getKey(
                                              report,
                                              '89_109',
                                              null,
                                              '__CLUTCH_IF__'
                                            ) &&
                                            b.tryCatch(
                                              conditionFn5,
                                              props,
                                              vars
                                            ) ? (
                                              <UseForm
                                                mode="all"
                                                defaultValues={{
                                                  offerID:
                                                    vars?.defaultUseParams2
                                                      ?.applicationID,
                                                  loginString:
                                                    vars?.defaultUseParams2
                                                      ?.loginString,
                                                }}
                                                key={getKey(
                                                  report,
                                                  'v200_103829'
                                                )}
                                              >
                                                {(
                                                  (prevReport) =>
                                                  (...args) => {
                                                    const [report, vars] =
                                                      b.getReport(
                                                        'v200_103829',
                                                        'children',
                                                        prevReport,
                                                        'useform3',
                                                        args
                                                      );

                                                    return [
                                                      <Box
                                                        tag="div"
                                                        className={
                                                          styles.clt_89_175
                                                        }
                                                        key={getKey(
                                                          report,
                                                          '89_175'
                                                        )}
                                                      >
                                                        <Text
                                                          text="Have you moved on to other opportunities?"
                                                          tag="h2"
                                                          className={
                                                            styles.clt_89_110
                                                          }
                                                          key={getKey(
                                                            report,
                                                            '89_110'
                                                          )}
                                                        />
                                                        <Text
                                                          text="Please let us know your plans — We would love to keep in contact and consider you for future opportunities."
                                                          tag="span"
                                                          className={
                                                            styles.clt_89_160
                                                          }
                                                          key={getKey(
                                                            report,
                                                            '89_160'
                                                          )}
                                                        />
                                                      </Box>,
                                                      <Box
                                                        tag="div"
                                                        className={
                                                          styles.clt_89_176
                                                        }
                                                        key={getKey(
                                                          report,
                                                          '89_176'
                                                        )}
                                                      >
                                                        <Controller
                                                          name="why"
                                                          control={
                                                            vars?.useform3
                                                              ?.control
                                                          }
                                                          render={(
                                                            (prevReport) =>
                                                            (...args) => {
                                                              const [
                                                                report,
                                                                vars,
                                                              ] = b.getReport(
                                                                '89_310',
                                                                'render',
                                                                prevReport,
                                                                'controller1',
                                                                args
                                                              );

                                                              return (
                                                                <ReactSelect
                                                                  onChange={
                                                                    vars
                                                                      ?.controller1
                                                                      ?.field
                                                                      ?.onChange
                                                                  }
                                                                  name={
                                                                    vars
                                                                      ?.controller1
                                                                      ?.field
                                                                      ?.name
                                                                  }
                                                                  value={
                                                                    vars
                                                                      ?.controller1
                                                                      ?.field
                                                                      ?.value
                                                                  }
                                                                  inputRef={
                                                                    vars
                                                                      ?.controller1
                                                                      ?.field
                                                                      ?.ref
                                                                  }
                                                                  placeholder="Let us know what happened"
                                                                  options={[
                                                                    {
                                                                      value:
                                                                        'another_opportunity',
                                                                      label:
                                                                        'I found another opportunity',
                                                                    },
                                                                    {
                                                                      value:
                                                                        'not_a_fit',
                                                                      label:
                                                                        'This was not a fit',
                                                                    },
                                                                  ]}
                                                                  key={getKey(
                                                                    report,
                                                                    '89_293'
                                                                  )}
                                                                />
                                                              );
                                                            }
                                                          )(report)}
                                                          rules={{
                                                            required: true,
                                                          }}
                                                          key={getKey(
                                                            report,
                                                            '89_310'
                                                          )}
                                                        />
                                                        <TextField
                                                          placeholder="Optionally, please share why you decided to pass on this opportunity. Here at Extern, we're always looking to improve and provide the best experience for our externs. No feedback is bad feedback!"
                                                          type="text"
                                                          register={b.tryCatch(
                                                            registerFn5,
                                                            props,
                                                            vars
                                                          )}
                                                          multiline
                                                          rows="3"
                                                          className={
                                                            styles.clt_91_0
                                                          }
                                                          key={getKey(
                                                            report,
                                                            '91_0'
                                                          )}
                                                          data-d={getKey(
                                                            report,
                                                            '91_0'
                                                          )}
                                                        />
                                                        <CheckboxField
                                                          label="Keep me in mind for future opportunities — This will allow us to reach out to you with exciting new experiences"
                                                          required={false}
                                                          register={b.tryCatch(
                                                            registerFn6,
                                                            props,
                                                            vars
                                                          )}
                                                          key={getKey(
                                                            report,
                                                            '89_211'
                                                          )}
                                                          data-d={getKey(
                                                            report,
                                                            '89_211'
                                                          )}
                                                        />
                                                        <Button
                                                          text="Decline Offer"
                                                          loading={b.tryCatch(
                                                            loadingFn1,
                                                            props,
                                                            vars
                                                          )}
                                                          disabled={b.tryCatch(
                                                            disabledFn1,
                                                            props,
                                                            vars
                                                          )}
                                                          rounded
                                                          size="medium"
                                                          color="info"
                                                          onClick={b.tryCatch(
                                                            onClickFn2,
                                                            props,
                                                            vars
                                                          )}
                                                          key={getKey(
                                                            report,
                                                            '89_229'
                                                          )}
                                                          data-d={getKey(
                                                            report,
                                                            '89_229'
                                                          )}
                                                        />
                                                        <Button1
                                                          onClick={b.tryCatch(
                                                            onClickFn3,
                                                            props,
                                                            vars
                                                          )}
                                                          type="button"
                                                          disabled={false}
                                                          className={
                                                            styles.clt_89_240
                                                          }
                                                          key={getKey(
                                                            report,
                                                            '89_240'
                                                          )}
                                                        >
                                                          <Text
                                                            text="I have changed my mind"
                                                            tag="span"
                                                            className={
                                                              styles.clt_89_241
                                                            }
                                                            key={getKey(
                                                              report,
                                                              '89_241'
                                                            )}
                                                          />
                                                        </Button1>
                                                      </Box>,
                                                      <Popup
                                                        open={b.tryCatch(
                                                          openFn,
                                                          props,
                                                          vars
                                                        )}
                                                        hideCloseButton
                                                        className={
                                                          styles.clt_93_23
                                                        }
                                                        key={getKey(
                                                          report,
                                                          '93_23'
                                                        )}
                                                        data-d={getKey(
                                                          report,
                                                          '93_23'
                                                        )}
                                                      >
                                                        {(
                                                          (prevReport) =>
                                                          (...args) => {
                                                            const [
                                                              report,
                                                              vars,
                                                            ] = b.getReport(
                                                              '93_23',
                                                              'children',
                                                              prevReport,
                                                              'popupfinishdeclineflow',
                                                              args
                                                            );

                                                            return (
                                                              <Box
                                                                tag="div"
                                                                className={
                                                                  styles.clt_93_28
                                                                }
                                                                key={getKey(
                                                                  report,
                                                                  '93_28'
                                                                )}
                                                              >
                                                                <Text
                                                                  text="Thanks for sharing!"
                                                                  tag="h2"
                                                                  className={
                                                                    styles.clt_93_29
                                                                  }
                                                                  key={getKey(
                                                                    report,
                                                                    '93_29'
                                                                  )}
                                                                />
                                                                <Text
                                                                  text="We hope to hear back from you soon!"
                                                                  tag="p"
                                                                  className={
                                                                    styles.clt_93_30
                                                                  }
                                                                  key={getKey(
                                                                    report,
                                                                    '93_30'
                                                                  )}
                                                                />
                                                                <Button
                                                                  text="Close This Tab"
                                                                  loading={
                                                                    false
                                                                  }
                                                                  disabled={
                                                                    false
                                                                  }
                                                                  rounded
                                                                  size="medium"
                                                                  onClick={b.tryCatch(
                                                                    onClickFn4,
                                                                    props,
                                                                    vars
                                                                  )}
                                                                  color="hint"
                                                                  className={
                                                                    styles.clt_93_31
                                                                  }
                                                                  key={getKey(
                                                                    report,
                                                                    '93_31'
                                                                  )}
                                                                  data-d={getKey(
                                                                    report,
                                                                    '93_31'
                                                                  )}
                                                                />
                                                              </Box>
                                                            );
                                                          }
                                                        )(report)}
                                                      </Popup>,
                                                    ];
                                                  }
                                                )(report)}
                                              </UseForm>
                                            ) : null}
                                          </Box>
                                        </Box>
                                      );
                                    }
                                  )(report)}
                                </UseState>
                              </Box>
                            ) : null}
                            <Box
                              tag="div"
                              style={{
                                paddingTop: b.tryCatch(styleFn, props, vars),
                              }}
                              className={styles.clt_84_310}
                              key={getKey(report, '84_310')}
                            >
                              <Text
                                text="Frequently Asked Questions"
                                tag="h2"
                                className={styles.clt_84_311}
                                key={getKey(report, '84_311')}
                              />
                              <Box
                                tag="div"
                                className={styles.clt_85_0}
                                key={getKey(report, '85_0')}
                              >
                                <Accordion
                                  title="I'm currently on an F-1 visa, does this experience require CPT?"
                                  defaultExpanded={false}
                                  key={getKey(report, '85_158')}
                                  data-d={getKey(report, '85_158')}
                                >
                                  <Text
                                    text={
                                      "Please be aware that as a student, you should always contact your school's international office/advisor and compliance officer for advice and approval before attempting to participate in Externships. Many international students have participated in externships with great success.   However, institutional approval and interpretation of federal guidelines may vary. We are here to provide you with support and documentation to begin the CPT process with guidance from your institution.\n\n"
                                    }
                                    tag="span"
                                    key={getKey(report, '85_120')}
                                  />
                                  <Box tag="div" key={getKey(report, '85_308')}>
                                    <Text
                                      text="Should you like to begin this process, please be aware that the timeliness of your request is important. Five (5) days are needed to process your request. Upon accepting your offer, please email us at "
                                      tag="span"
                                      key={getKey(report, '85_304')}
                                    />
                                    <Link
                                      href="mailto:help@extern.com"
                                      className={styles.clt_85_319}
                                      key={getKey(report, '85_319')}
                                    >
                                      <Text
                                        text="help@extern.com"
                                        tag="span"
                                        key={getKey(report, '85_320')}
                                      />
                                    </Link>
                                    <Text
                                      text={
                                        ' to confirm that you have signed your offer letter. As a reminder, institutional approval is required prior to beginning the experience. Your offer and acceptance of the offer is conditional until we receive a formal approval from your university.\n\n'
                                      }
                                      tag="span"
                                      key={getKey(report, '85_309')}
                                    />
                                  </Box>
                                  <Box tag="div" key={getKey(report, '85_286')}>
                                    <Text
                                      text="Note: "
                                      tag="span"
                                      className={styles.clt_85_278}
                                      key={getKey(report, '85_278')}
                                    />
                                    <Text
                                      text="Until you’ve received explicit approval from your advisor or compliance officer, we recommend you do not do any work in your student app."
                                      tag="span"
                                      key={getKey(report, '85_287')}
                                    />
                                  </Box>
                                </Accordion>
                                <Accordion
                                  title="How will I start this experience? What do I do after I accept my offer?"
                                  defaultExpanded={false}
                                  key={getKey(report, '85_248')}
                                  data-d={getKey(report, '85_248')}
                                >
                                  <Text
                                    text="On the start date of your experience, you'll receive an email with instructions on how to set up your student platform account and other to do's. Meanwhile, we encourage you to do some basic research on the industry your experience will focus on."
                                    tag="span"
                                    key={getKey(report, '85_249')}
                                  />
                                </Accordion>
                                <Accordion
                                  title="Can I change the start date or end date for my program?"
                                  defaultExpanded={false}
                                  key={getKey(report, '85_250')}
                                  data-d={getKey(report, '85_250')}
                                >
                                  <Text
                                    text="We do not accommodate start date change requests since most cohorts of students begin at the same time. However, this does not mean you’ll be behind if you are unavailable at the start of your program. Due to the asynchronous and flexible nature of the program, you will still be able to participate with great success. You will be able to progress at your own pace and at your own time as long as you finish all your responsibilities by your end date."
                                    tag="span"
                                    key={getKey(report, '85_251')}
                                  />
                                </Accordion>
                              </Box>
                            </Box>
                          </Element>
                        ) : null,
                        getKey(report, '87_15', null, '__CLUTCH_IF__') &&
                        b.tryCatch(conditionFn7, props, vars) ? (
                          <Element key={getKey(report, 'v200_103705')}>
                            <OfferLetterHero
                              mode="accepted"
                              applicationOffer={
                                vars?.useapplicationoffer2?.applicationOffer
                              }
                              onViewOfferDetails={b.tryCatch(
                                onViewOfferDetailsFn,
                                props,
                                vars
                              )}
                              key={getKey(report, '87_49')}
                              data-d={getKey(report, '87_49')}
                            />
                            {getKey(report, '155_49', null, '__CLUTCH_IF__') &&
                            b.tryCatch(conditionFn11, props, vars) ? (
                              <Box
                                tag="div"
                                className={styles.clt_87_48}
                                key={getKey(report, '87_48')}
                              >
                                <Box
                                  tag="div"
                                  className={styles.clt_87_54}
                                  key={getKey(report, '87_54')}
                                >
                                  <Box
                                    tag="div"
                                    className={styles.clt_87_56}
                                    key={getKey(report, '87_56')}
                                  >
                                    <Box
                                      tag="div"
                                      className={styles.clt_87_57}
                                      key={getKey(report, '87_57')}
                                    >
                                      <Box
                                        tag="div"
                                        className={styles.clt_87_58}
                                        key={getKey(report, '87_58')}
                                      >
                                        <Box
                                          tag="div"
                                          className={styles.clt_87_59}
                                          key={getKey(report, '87_59')}
                                        />
                                      </Box>
                                      <Box
                                        tag="div"
                                        className={styles.clt_87_60}
                                        key={getKey(report, '87_60')}
                                      >
                                        <Box
                                          tag="div"
                                          className={styles.clt_87_61}
                                          key={getKey(report, '87_61')}
                                        />
                                        <Box
                                          tag="div"
                                          className={styles.clt_87_62}
                                          key={getKey(report, '87_62')}
                                        />
                                      </Box>
                                    </Box>
                                  </Box>
                                  <Box
                                    tag="div"
                                    className={styles.clt_87_55}
                                    key={getKey(report, '87_55')}
                                  />
                                  <Box
                                    tag="div"
                                    className={styles.clt_87_63}
                                    key={getKey(report, '87_63')}
                                  >
                                    <Box
                                      tag="div"
                                      className={styles.clt_87_64}
                                      key={getKey(report, '87_64')}
                                    >
                                      <Box
                                        tag="div"
                                        className={styles.clt_87_65}
                                        key={getKey(report, '87_65')}
                                      >
                                        <Box
                                          tag="div"
                                          className={styles.clt_87_66}
                                          key={getKey(report, '87_66')}
                                        />
                                      </Box>
                                      <Box
                                        tag="div"
                                        className={styles.clt_87_67}
                                        key={getKey(report, '87_67')}
                                      >
                                        <Box
                                          tag="div"
                                          className={styles.clt_87_68}
                                          key={getKey(report, '87_68')}
                                        />
                                        <Box
                                          tag="div"
                                          className={styles.clt_87_69}
                                          key={getKey(report, '87_69')}
                                        />
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>
                                <Box
                                  tag="div"
                                  className={styles.clt_87_70}
                                  key={getKey(report, '87_70')}
                                >
                                  <Text
                                    text="Feel free to shout it from the rooftops!"
                                    tag="h3"
                                    className={styles.clt_87_51}
                                    key={getKey(report, '87_51')}
                                  />
                                  <Text
                                    text={
                                      "Or better still, from your social media.\nIt's never too early to start building your professional presence online."
                                    }
                                    tag="p"
                                    className={styles.clt_87_52}
                                    key={getKey(report, '87_52')}
                                  />
                                  {getKey(
                                    report,
                                    '87_53',
                                    null,
                                    '__CLUTCH_IF__'
                                  ) && b.tryCatch(conditionFn8, props, vars) ? (
                                    <Image
                                      src={b.tryCatch(srcFn, props, vars)}
                                      className={styles.clt_v200_103801}
                                      key={getKey(report, 'v200_103801')}
                                    />
                                  ) : null}
                                  <Box
                                    tag="div"
                                    className={styles.clt_94_10}
                                    key={getKey(report, '94_10')}
                                  >
                                    {getKey(
                                      report,
                                      '135_404',
                                      null,
                                      '__CLUTCH_LOOP__'
                                    ) &&
                                      b
                                        .tryCatch(itemsFn1, props, vars)
                                        ?.map((item, index, items) =>
                                          (
                                            (prevReport) =>
                                            (...args) => {
                                              const [report, vars] =
                                                b.getReport(
                                                  '135_404',
                                                  'children',
                                                  prevReport,
                                                  'loop',
                                                  args
                                                );

                                              return (
                                                <Box
                                                  tag="div"
                                                  className={styles.clt_94_107}
                                                  key={getKey(
                                                    report,
                                                    '94_107',
                                                    vars?.loop?.item?.icon
                                                  )}
                                                >
                                                  <IfElse
                                                    if={
                                                      <TooltipClickWrapper
                                                        label="Link copied to clipboard!"
                                                        beforeLabel={
                                                          <Icon
                                                            name="link"
                                                            key={getKey(
                                                              report,
                                                              '99_457'
                                                            )}
                                                            data-d={getKey(
                                                              report,
                                                              '99_457'
                                                            )}
                                                          />
                                                        }
                                                        timer="2000"
                                                        onClick={
                                                          vars?.loop?.item
                                                            ?.onClick
                                                        }
                                                        className={b.cx([
                                                          styles.clt_98_368,
                                                          'tooltipWrapper-label',
                                                        ])}
                                                        key={getKey(
                                                          report,
                                                          '98_368'
                                                        )}
                                                      >
                                                        <Button1
                                                          type="button"
                                                          disabled={false}
                                                          className={
                                                            styles.clt_99_419
                                                          }
                                                          key={getKey(
                                                            report,
                                                            '99_419'
                                                          )}
                                                        >
                                                          <Icon
                                                            name={
                                                              vars?.loop?.item
                                                                ?.icon
                                                            }
                                                            className={
                                                              styles.clt_99_420
                                                            }
                                                            key={getKey(
                                                              report,
                                                              '99_420'
                                                            )}
                                                            data-d={getKey(
                                                              report,
                                                              '99_420'
                                                            )}
                                                          />
                                                        </Button1>
                                                      </TooltipClickWrapper>
                                                    }
                                                    else={
                                                      <TooltipWrapper
                                                        label={
                                                          vars?.loop?.item
                                                            ?.label
                                                        }
                                                        hide={b.tryCatch(
                                                          hideFn,
                                                          props,
                                                          vars
                                                        )}
                                                        key={getKey(
                                                          report,
                                                          '94_240'
                                                        )}
                                                        data-d={getKey(
                                                          report,
                                                          '94_240'
                                                        )}
                                                      >
                                                        <Button1
                                                          onClick={
                                                            vars?.loop?.item
                                                              ?.onClick
                                                          }
                                                          type="button"
                                                          disabled={false}
                                                          className={
                                                            styles.clt_94_11
                                                          }
                                                          key={getKey(
                                                            report,
                                                            '94_11'
                                                          )}
                                                        >
                                                          <Icon
                                                            name={
                                                              vars?.loop?.item
                                                                ?.icon
                                                            }
                                                            className={
                                                              styles.clt_94_83
                                                            }
                                                            key={getKey(
                                                              report,
                                                              '94_83'
                                                            )}
                                                            data-d={getKey(
                                                              report,
                                                              '94_83'
                                                            )}
                                                          />
                                                        </Button1>
                                                      </TooltipWrapper>
                                                    }
                                                    condition={b.tryCatch(
                                                      conditionFn9,
                                                      props,
                                                      vars
                                                    )}
                                                    key={getKey(
                                                      report,
                                                      '98_359'
                                                    )}
                                                  />
                                                  {getKey(
                                                    report,
                                                    '94_108',
                                                    null,
                                                    '__CLUTCH_IF__'
                                                  ) &&
                                                  b.tryCatch(
                                                    conditionFn10,
                                                    props,
                                                    vars
                                                  ) ? (
                                                    <Text
                                                      text={b.tryCatch(
                                                        textFn12,
                                                        props,
                                                        vars
                                                      )}
                                                      tag="span"
                                                      className={
                                                        styles.clt_v200_103764
                                                      }
                                                      key={getKey(
                                                        report,
                                                        'v200_103764'
                                                      )}
                                                    />
                                                  ) : null}
                                                </Box>
                                              );
                                            }
                                          )(report)?.({ item, index, items })
                                        )}
                                  </Box>
                                </Box>
                              </Box>
                            ) : null}
                          </Element>
                        ) : null,
                        getKey(report, '95_336', null, '__CLUTCH_IF__') &&
                        b.tryCatch(conditionFn12, props, vars) ? (
                          <Element key={getKey(report, 'v200_103783')}>
                            <Box
                              tag="div"
                              className={styles.clt_95_341}
                              key={getKey(report, '95_341')}
                            >
                              <PoweredByParagonOne
                                key={getKey(report, '95_337')}
                                data-d={getKey(report, '95_337')}
                              />
                              <Box
                                tag="div"
                                className={styles.clt_96_7}
                                key={getKey(report, '96_7')}
                              >
                                <Text
                                  text={b.tryCatch(textFn13, props, vars)}
                                  tag="span"
                                  className={styles.clt_95_363}
                                  key={getKey(report, '95_363')}
                                />
                                <Text
                                  text={
                                    'It seems like it was not the best moment for you to tackle this opportunity.\nWe hope to hear back from you soon!'
                                  }
                                  tag="p"
                                  className={styles.clt_95_365}
                                  key={getKey(report, '95_365')}
                                />
                              </Box>
                            </Box>
                          </Element>
                        ) : null,
                        getKey(report, '82_439', null, '__CLUTCH_IF__') &&
                        vars?.useapplicationoffer2?.isLoading ? (
                          <Loading
                            className={styles.clt_v200_98866}
                            key={getKey(report, 'v200_98866')}
                            data-d={getKey(report, 'v200_98866')}
                          />
                        ) : null,
                        getKey(report, '96_272', null, '__CLUTCH_IF__') &&
                        b.tryCatch(conditionFn13, props, vars) ? (
                          <_404
                            key={getKey(report, 'v200_103998')}
                            data-d={getKey(report, 'v200_103998')}
                          />
                        ) : null,
                      ];
                    }
                  )(report)}
                </UseApplicationOffer>
              );
            }
          )(report)}
        </UseParams>
      </Box>
    </>
  );
});

OfferLetterPage.displayName = 'OfferLetterPage';

export default OfferLetterPage;
